
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7d5b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7d5b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $9jJkP = parcelRequire("9jJkP");
const $c2716924d58fdd1b$var$itemsContainer = document.querySelector('.items__wrapper');
(0, $9jJkP.default).forEach((item, index)=>{
    const newItem = document.createElement('div');
    newItem.classList.add('items__item');
    // newItem.setAttribute('data-aos', 'fade-up');
    newItem.setAttribute('data-category', `${item.category}`);
    newItem.setAttribute('data-index', index);
    const leftCol = document.createElement('div');
    leftCol.classList.add('items__item__left');
    const leftColHeading = document.createElement('h3');
    leftColHeading.textContent = `${index + 1}. ${item.name}`;
    leftCol.append(leftColHeading);
    const leftColDescription = document.createElement('p');
    leftColDescription.textContent = item.description;
    leftCol.append(leftColDescription);
    const technicalData = document.createElement('div');
    technicalData.classList.add('items__item__technical-data');
    const headingTechnicalData = document.createElement('p');
    headingTechnicalData.textContent = 'Dane Techniczne';
    technicalData.append(headingTechnicalData);
    const technicalList = document.createElement('ul');
    item.technical_data.forEach((element)=>{
        if (element.name.length > 0) {
            const liElement = document.createElement('li');
            liElement.textContent = `${element.name}: `;
            const liElementValue = document.createElement('strong');
            liElementValue.textContent = element.value;
            liElement.append(liElementValue);
            technicalList.append(liElement);
            leftCol.append(technicalList);
        }
    });
    const price = document.createElement('div');
    price.classList.add('items__item__price');
    const priceList = document.createElement('ul');
    const price1 = document.createElement('li');
    price1.innerHTML = `Cena: <strong>${item.price.rental_price}</strong>`;
    const price2 = document.createElement('li');
    price2.innerHTML = `Kaucja:<strong>${item.price.deposit}</strong>`;
    priceList.append(price1);
    priceList.append(price2);
    price.append(priceList);
    leftCol.append(price);
    newItem.append(leftCol);
    const rightCol = document.createElement('div');
    rightCol.classList.add('items__item__right');
    if (item.image) {
        const rightImg = document.createElement('img');
        rightImg.src = item.image instanceof URL ? item.image.href : item.image;
        rightImg.alt = item.name;
        rightCol.append(rightImg);
    } else {
        const noImg = document.createElement('div');
        noImg.classList.add('items__item__no-image');
        noImg.textContent = "Brak zdj\u0119cia";
        rightCol.append(noImg);
    }
    const rightCategory = document.createElement('p');
    rightCategory.innerHTML = `<strong>Kategoria:</strong> ${item.category}`;
    rightCol.append(rightCategory);
    rightCol.append(rightCategory);
    newItem.append(rightCol);
    $c2716924d58fdd1b$var$itemsContainer.append(newItem);
});
const $c2716924d58fdd1b$var$filterItems = (category)=>{
    const items = document.querySelectorAll('.items__item');
    items.forEach((item)=>{
        if (category === 'Wszystkie' || item.getAttribute('data-category') === category) item.style.display = 'flex';
        else item.style.display = 'none';
    });
    const activeLink = document.querySelector('.filters a.active');
    if (activeLink) activeLink.classList.remove('active');
    const selectedLink = document.querySelector(`.filters a[data-category="${category}"]`);
    selectedLink.classList.add('active');
    $c2716924d58fdd1b$var$categories.forEach((category, index)=>{
        if (index === categoriesArray.length - 1) a.classList.add('bold');
    });
};
const $c2716924d58fdd1b$var$filters = document.querySelector('.filters');
const $c2716924d58fdd1b$var$categories = new Set((0, $9jJkP.default).map((item)=>item.category));
$c2716924d58fdd1b$var$categories.forEach((category)=>{
    $c2716924d58fdd1b$var$categories.add('Wszystkie');
    const categoriesArray1 = Array.from($c2716924d58fdd1b$var$categories);
    categoriesArray1.unshift('Wszystkie');
    const li = document.createElement('li');
    const a1 = document.createElement('a');
    a1.setAttribute('href', '#');
    a1.setAttribute('data-category', category);
    a1.textContent = category;
    li.appendChild(a1);
    $c2716924d58fdd1b$var$filters.appendChild(li);
    a1.addEventListener('click', (event)=>{
        event.preventDefault();
        const category = event.target.getAttribute('data-category');
        $c2716924d58fdd1b$var$filterItems(category);
    });
});
const $c2716924d58fdd1b$var$links = document.querySelectorAll('.filters a');
const $c2716924d58fdd1b$var$lastLink = $c2716924d58fdd1b$var$links[$c2716924d58fdd1b$var$links.length - 1];
$c2716924d58fdd1b$var$lastLink.classList.add('active');


//# sourceMappingURL=cennik-maszyn.b81cc7e2.js.map
